import React from 'react'
import schema from '../jsonschemas/infrastructure/infrastructure_4/infrastructure_four.json'
import uiSchema from '../jsonschemas/infrastructure/infrastructure_4/web_ui_schema.json'
import { FormPreview } from './FormPreview'

export function TestSchema4() {
  return <FormPreview schema={schema} uiSchema={uiSchema} />
}
